import React from 'react';
import './BankDetails.css';
import mufg from "./assets/mufg.png";

const BankDetails = () => {
  return (
    <div className="container-fluid bank-details-page py-5">

      {/* Image Cards Section */}
      <div className="row g-4 justify-content-center mb-5">
        <div className="col-md-4 col-lg-12">
          <div className="image-card">
            <img
              src={mufg}
              alt="MUFJ Bank"
              className="img-fluid"
            />

            <div className='disclaim-tex'><h2>Disclaimer:</h2></div>
            <div className="marquee" aria-hidden="true">
              <div className="marquee__inner" aria-hidden="true">
                <span>🔥 All customers must send money to SKC Japan given bank accounts. SKC Japan will not be responsible for any payment made in accounts other then given on our website. 🔥 &nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span>🔥 All customers must send money to SKC Japan given bank accounts. SKC Japan will not be responsible for any payment made in accounts other then given on our website. 🔥 &nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span>🔥 All customers must send money to SKC Japan given bank accounts. SKC Japan will not be responsible for any payment made in accounts other then given on our website. 🔥 &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </div>
            </div>

            <div style={{display:"none"}} aria-live="polite">
              All customers must send money to SKC Japan given bank accounts. SKC Japan will not be responsible for any payment made in accounts other then given on our website.
            </div>

          </div>
        </div>
      </div>

      {/* Bank Details Section with Bootstrap Table and Right-Side Image */}
      <div className="row justify-content-center mt-5">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-lg bank-info-card p-4">
            <div className='bank-header'>
              <h4 className="card-title mb-4">
                <i className="fas fa-university me-2"></i>Banking Details
              </h4>
              <hr className='hr-line'></hr>
              <p>Beneficiary Banking Details (International Wire Transfers)</p>
              <p>Kindly find the Complete Banking Details as below & do ensure the same banking details while transfer</p>
            </div>

            <table className="table table-striped table-hover">
              <tbody>
                <tr>
                  <th scope="row">Bank Name</th>
                  <td>Mitsubishi Tokyo UFJ Bank LTD</td>
                </tr>
                <tr>
                  <th scope="row">Beneficiary Name</th>
                  <td>S.K Co. LTD</td>
                </tr>
                <tr>
                  <th scope="row">Branch Code</th>
                  <td>08 1</td>
                </tr>
                <tr>
                  <th scope="row">Account Number</th>
                  <td>027 8552</td>
                </tr>
                <tr>
                  <th scope="row">Branch Name</th>
                  <td>Oshiage Branch</td>
                </tr>
                <tr>
                  <th scope="row">SWIFT Code</th>
                  <td>BOTKJPJT</td>
                </tr>
                <tr>
                  <th scope="row">Bank Address</th>
                  <td>3-14-5 Narihira, Tokyo, Japan</td>
                </tr>
              </tbody>
            </table>
            <p className="mt-3 text-muted">
              Ensure all transactions are made to the above account details. For international transfers, please include the SWIFT code.
            </p>
          </div>
        </div>
      </div>

      <div className="row justify-content-center mt-5">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-lg bank-info-card p-4">
            <div className='bank-header'>
              <h4 className="card-title mb-4">
                Intermediary Beneficiary Banking Details
              </h4>
            </div>

            <table className="table table-striped table-hover">
              <tbody>
                <tr>
                  <th scope="row">Bank Name</th>
                  <td>The Bank of Tokyo Mitsubishi UFJ, LTD</td>
                </tr>
                <tr>
                  <th scope="row">Branch Name</th>
                  <td>New York Branch</td>
                </tr>
                <tr>
                  <th scope="row">Branch Address</th>
                  <td>1251 Avenue of the Americas, New York, NY 10020-1104 U.S.A.</td>
                </tr>
                <tr>
                  <th scope="row">Swift Code</th>
                  <td>BOTKUS33</td>
                </tr>
              </tbody>
            </table>
            <p className="mt-3 text-muted">
              Ensure all transactions are made to the above account details. For international transfers, please include the SWIFT code.
            </p>
          </div>
        </div>
      </div>

      {/* Footer Text */}
      <div className="text-center mt-5">
        <p className="text-muted">
          For payment confirmation or inquiries, please contact us at:{' '}
          <a href="mailto:support@skcjapan.com" className="text-primary">support@skcjapan.com</a>
        </p>
        <p className="text-muted">
          SKC Japan is committed to providing secure and reliable financial transactions for all our clients.
        </p>
      </div>
    </div>
  );
};

export default BankDetails;